module.exports = __webpack_public_path__ + "static/media/exterior_front.7db31dfc.png";